import { useCallback, useContext, useState } from "react";
import GlobalContext from "../../context/GlobalContext";
import DataTableComponent from "./DataTableComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import swal from "../../services/swalConfig";
import CopyText from "../utilities/CopyText";
// Import fungsi API untuk Payroll Template
import { fetchTemplatePayroll, deleteTemplate } from "../../api/PayrollApi";
import { format } from "date-fns";

import { tr } from "../../i18n";
const TablePayrollTemplates = ({ refresh }) => {
  const { user, setLoading } = useContext(GlobalContext);
  const [reload, setReload] = useState(0);
  const navigate = useNavigate();

  // 1. Fungsi untuk mengambil data template payroll (tetap sama)
  const fetchData = useCallback(
    async ({ page, perPage, search }) => {
      if (!user?.workspace?.company_id) return { data: [], total: 0 };

      const response = await fetchTemplatePayroll({
        companyId: user.workspace.company_id,
        page,
        perPage,
        search,
      });

      const numberedData = response.data.map((item, index) => ({
        ...item,
        no: (page - 1) * perPage + index + 1,
      }));

      return { data: numberedData, total: response.total };
    },
    [user.workspace.company_id, reload, refresh]
  );

  // 2. Fungsi untuk menangani Edit (tetap sama)
  const handleEdit = (row) => {
    navigate(`/payroll/form?template=${row.id}`);
  };

  // 3. FUNGSI BARU: Logic Delete yang terpisah (Mirip processDelete)
  const processDelete = async (id) => {
    try {
      setLoading(true);

      const data = {
        // Tambahkan company_id seperti yang dilakukan di TableSchedules
        company_id: user.workspace.company_id,
        id: id,
      };

      const response = await deleteTemplate(data);

      // Cek status respons secara eksplisit
      if (response.status == 200) {
        swal.fire({
          title: tr("payroll:deleted"),
          text: response.message || tr("payroll:the_payroll_template_has_been_deleted"),
          icon: "success",
          showCancelButton: false,
        });

        // Panggil setReload untuk memuat ulang tabel
        setReload((prev) => prev + 1);
      } else {
        // Tangani jika API mengembalikan status non-200 atau pesan error di body
        swal.fire({
          title: tr("common:errors.oops"),
          text: response.message || tr("payroll:failed_to_delete_template"),
          icon: "error",
          showCancelButton: false,
        });
      }
    } catch (error) {
      // Tangani error jaringan/kesalahan tak terduga
      swal.fire({
        title: tr("payroll:error"),
        text: tr("common:errors.generic"),
        icon: "error",
        showCancelButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  // 4. FUNGSI BARU: Konfirmasi Delete (Mirip handleDelete)
  const handleDelete = async (id) => {
    const result = await swal.fire({
      title: tr("shared:are_you_sure"),
      text: tr("payroll:you_won_t_be_able_to_2"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: tr("shared:i_understand_delete"),
      confirmButtonColor: "#f10f29ff",
      cancelButtonText: tr("common:actions.cancel"),
      timer: false,
    });

    if (result.isConfirmed) {
      processDelete(id);
    }
  };

  // 5. Definisi Kolom Tabel (tetap sama)
  const columns = [
    { name: tr("shared:no"), selector: (row) => row.no, width: "70px", sortable: true },
    {
      name: tr("payroll:id_template"),
      cell: (row) => <CopyText text={row.id} />,
      sortable: true,
      wrap: true,
      width: "15%",
    },
    {
      name: tr("payroll:template_name_2"),
      selector: (row) => row.template_name,
      sortable: true,
      wrap: true,
      width: "30%",
    },
    {
      name: tr("payroll:created_at"),
      // Gunakan cell property untuk rendering kustom
      cell: (row) =>
        row.created_at ? format(new Date(row.created_at), "dd MMMM yyyy") : "-",
      sortable: true,
      wrap: false,
    },
    {
      name: tr("shared:actions"),
      center: true,
      cell: (row) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            onClick={() => handleEdit(row)}
            className="btn btn-primary btn-sm"
          >
            <FontAwesomeIcon icon={faEdit} className="me-1" /> {" "}{tr("common:breadcrumb.edit")}
          </button>
          <button
            onClick={() => handleDelete(row.id)}
            className="btn btn-danger btn-sm"
          >
            <FontAwesomeIcon icon={faTrash} className="me-1" /> {" "}{tr("common:actions.delete")}
          </button>
        </div>
      ),
    },
  ];

  return <DataTableComponent columns={columns} fetchData={fetchData} />;
};

export default TablePayrollTemplates;
